import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { observer } from 'mobx-react-lite';
import { useCallback, useState } from 'react';
import { ClassificationStrategy } from '../../common/types';
import type { GeoPointLocation } from '../../esri/types';
import { LocationSelect } from '../../location-select/components/location-select';
import { LocationSelectV1 } from '../../location-select/components/location-select-v1';
import { useEsriMapStore } from '../hooks/use-esri-map-store';
import { isValidLatLng } from '../../location/helpers';
import type { LocationStoreView } from '../../location/types';
import { getUniqueIdFromLocationView } from '../../esri/helpers/locations';

export const LocationSearchInput = observer(function LocationSearchInput(): React.ReactElement {
    const mapStore = useEsriMapStore();
    const [pendingLocation, setPendingLocation] = useState<LocationStoreView | null>(null);
    const { subpremiseSupport, multiAgencySubdivisions } = useEnabledFeatures();

    const handleLocationChange = useCallback(
        (location: LocationStoreView | null) => {
            setPendingLocation(location);
            if (!location) {
                mapStore.clearGeoPointLocationAndAddress();
            } else if (location && isValidLatLng(location.latitude, location.longitude)) {
                const uniqueId = getUniqueIdFromLocationView(location);
                const locationSearchSelectedGeoPointLocation: GeoPointLocation = {
                    entityId: uniqueId,
                    ...location,
                };

                mapStore.showLocationOnTheMap(locationSearchSelectedGeoPointLocation);
            }
        },
        [setPendingLocation, mapStore]
    );

    if (!subpremiseSupport) {
        return (
            <LocationSelectV1
                hideLocationSummaryAdditionalLines
                placeholder="Location"
                // @ts-expect-error null
                value={pendingLocation}
                // @ts-expect-error null
                onChange={handleLocationChange}
                classificationStrategy={
                    multiAgencySubdivisions
                        ? ClassificationStrategy.MULTI_AGENCY
                        : ClassificationStrategy.SINGLE_AGENCY
                }
            />
        );
    }
    return (
        <LocationSelect
            placeInputOutside
            hideLocationSummaryAdditionalLines
            placeholder="Use # for sub-premises"
            // @ts-expect-error null
            value={pendingLocation}
            // @ts-expect-error null
            onChange={handleLocationChange}
            classificationStrategy={
                multiAgencySubdivisions
                    ? ClassificationStrategy.MULTI_AGENCY
                    : ClassificationStrategy.SINGLE_AGENCY
            }
        />
    );
});
